import * as CONSTANTS from "../utils/constants/constants";
import axios from "./axiosInstance";

// Note: Axios automatically serializes JSON data, no manual stringification needed
axios.interceptors.request.use((config: any) => {
  if (config.method === "delete" && config.data) {
    config.headers["Content-Type"] = "application/json";
    // Removed JSON.stringify - axios handles this automatically
  }
  return config;
});

class SupportServerService {
  // Get all server credentials for the user's organization
  static getAllSupportServers() {
    return CONSTANTS.HOST + "api/v1/server-credentials/";
  }

  // Get credentials by server type
  static getSupportServerByType(server_type: string) {
    return CONSTANTS.HOST + "api/v1/server-credentials/" + server_type + "/";
  }

  // Create or update server credentials (admin only)
  static manageSupportServer(data: any, access_token: string) {
    return axios
      .post(CONSTANTS.HOST + "api/v1/server-credentials/manage/", data, {
        headers: { authorization: "Bearer " + access_token },
      })
      .then((response: any) => response)
      .catch((err: any) => {
        return Promise.reject(err.response);
      });
  }

  // Delete server credentials (admin only)
  static deleteSupportServer(server_id: string, access_token: string) {
    console.log("Deleting server with ID:", server_id);

    const payload = { server_id: server_id };
    console.log("Delete payload:", payload);
    console.log("Delete payload JSON:", JSON.stringify(payload));

    return axios
      .delete(CONSTANTS.HOST + "api/v1/server-credentials/delete/", {
        headers: {
          authorization: "Bearer " + access_token,
        },
        data: payload,
      })
      .then((response: any) => {
        console.log("Delete response:", response);
        return response;
      })
      .catch((err: any) => {
        console.log("Delete error in service:", err);
        console.log("Delete error response:", err.response);
        console.log("Delete error data:", err.response?.data);
        console.log("Request config:", err.config);
        console.log("Request data sent:", err.config?.data);
        return Promise.reject(err.response || err);
      });
  }

  // ===== Organization Support Server Management APIs =====

  // Get organization support server configuration (deprecated - use getAssignedServers instead)
  static getOrgSupportServerConfig(
    organization_id: string,
    access_token: string,
  ) {
    return axios
      .get(
        CONSTANTS.HOST +
          `api/v1/organizations/${organization_id}/support-servers/`,
        {
          headers: { authorization: "Bearer " + access_token },
        },
      )
      .then((response: any) => response.data)
      .catch((err: any) => {
        console.log(err);
        return Promise.reject(err.response || err);
      });
  }

  // Get available servers for assignment
  static getAvailableServers(
    organization_id: string,
    server_type: string,
    access_token: string,
  ) {
    const url =
      CONSTANTS.HOST +
      `api/v1/organizations/${organization_id}/servers/${server_type}/available/`;

    console.log("=== SupportServerService.getAvailableServers ===");
    console.log("Full URL:", url);
    console.log("Organization ID:", organization_id);
    console.log("Server Type:", server_type);
    console.log("Access Token exists:", !!access_token);
    console.log("Access Token length:", access_token?.length);

    return axios
      .get(url, {
        headers: { authorization: "Bearer " + access_token },
      })
      .then((response: any) => {
        console.log("=== getAvailableServers SUCCESS ===");
        console.log("Response status:", response.status);
        console.log("Response data:", response.data);
        return response.data;
      })
      .catch((err: any) => {
        console.error("=== getAvailableServers ERROR ===");
        console.error("Error:", err);
        console.error("Error response:", err.response);
        console.error("Error response status:", err.response?.status);
        console.error("Error response data:", err.response?.data);
        console.error("Error message:", err.message);
        console.error("Request URL:", err.config?.url);
        return Promise.reject(err.response || err);
      });
  }

  // Get assigned servers
  static getAssignedServers(organization_id: string, access_token: string) {
    return axios
      .get(
        CONSTANTS.HOST +
          `api/v1/organizations/${organization_id}/servers/assigned/`,
        {
          headers: { authorization: "Bearer " + access_token },
        },
      )
      .then((response: any) => response.data)
      .catch((err: any) => {
        console.log(err);
        return Promise.reject(err.response || err);
      });
  }

  // Assign server to organization
  static assignServer(
    organization_id: string,
    server_id: string,
    access_token: string,
    custom_auth_token?: string,
    custom_config?: any,
  ) {
    const payload: any = { server_id };

    // Add optional custom credentials if provided
    if (custom_auth_token) {
      payload.custom_auth_token = custom_auth_token;
    }
    if (custom_config) {
      payload.custom_config = custom_config;
    }

    return axios
      .post(
        CONSTANTS.HOST +
          `api/v1/organizations/${organization_id}/servers/assign/`,
        payload,
        {
          headers: { authorization: "Bearer " + access_token },
        },
      )
      .then((response: any) => response.data)
      .catch((err: any) => {
        console.log(err);
        return Promise.reject(err.response || err);
      });
  }

  // Unassign server from organization
  static unassignServer(
    organization_id: string,
    server_id: string,
    access_token: string,
  ) {
    return axios
      .post(
        CONSTANTS.HOST +
          `api/v1/organizations/${organization_id}/servers/unassign/`,
        { server_id },
        {
          headers: { authorization: "Bearer " + access_token },
        },
      )
      .then((response: any) => response.data)
      .catch((err: any) => {
        console.log(err);
        return Promise.reject(err.response || err);
      });
  }
}

export default SupportServerService;
